// extracted by mini-css-extract-plugin
module.exports = {"csr_h5_B":"B_csr_h5_B__GMn_E"};